import urls from "./utils/urls";
import { siteCall } from "./utils/WebCall";

export const addBot = async (data, context) => {
  console.log("Added Bot", data);
  return siteCall({
    url: urls.base_url + "/bot/join",
    method: "POST",
    body: JSON.stringify({
      meeting_url: data.meeting_url,
      bot_name: "MeetMinutes",
      user_id: data.user_id,
    }),
    successCallback: (response) => {
      return response.data;
    },
    errorCallback: (error) => {
      console.log(error, "error in fetching");
      return error;
    },
    headers: {
      "api-key": "2de03e3b-f8b1-42e5-bfbf-7e53ec33bafe",
    },
  });
};

export const getBotStatus = async (data, successCallback, errorCallback) => {
  return siteCall({
    url: urls.base_url + "/bot/get_status",
    method: "POST",
    body: JSON.stringify({
      bot_id: data.bot_id,
    }),
    successCallback: successCallback,
    errorCallback: errorCallback,
  });
};

export const getUniversalInsights = async (data, context) => {
  return siteCall({
    url: urls.base_url + "/insights/any-english",
    method: "POST",
    body: JSON.stringify({
      transcript_vtt: `${data.transcript_vtt}`,
      participant: `${data.participant}`,
    }),
    successCallback: (response) => {
      return response.data;
    },
    errorCallback: (error) => {
      console.log(error, "error in fetching");
      return error;
    },
    headers: {
      "api-key": "2de03e3b-f8b1-42e5-bfbf-7e53ec33bafe",
    },
  });
};

export const getTranscribeAndSummarize = async (data, context) => {
  return siteCall({
    url: urls.base_url + "/utils/transcribe_and_summarize",
    method: "POST",
    body: JSON.stringify({
      bot_id: `${data.bot_id}`,
      user_id: `${data.user_id}`,
      internal_language_code: `${data.internal_language_code}`,
      document_id: `${data.document_id}`,
      meeting_collection: `${data.meeting_collection}`,
    }),
    successCallback: (response) => {
      return response.data;
    },
    errorCallback: (error) => {
      console.log(error, "error in fetching");
      return error;
    },
    headers: {
      "api-key": "2de03e3b-f8b1-42e5-bfbf-7e53ec33bafe",
    },
  });
};

export const getTranscription = async (data, context) => {
  return siteCall({
    url: urls.base_url + "/upload_audio/get_transcription",
    method: "POST",
    body: JSON.stringify({
      audio_url: `${data.audio_url}`,
      internal_language_code: `${data.internal_language_code}`,
    }),
    successCallback: (response) => {
      return response.data;
    },
    errorCallback: (error) => {
      console.log(error, "error in fetching");
      return error;
    },
    headers: {
      "api-key": "2de03e3b-f8b1-42e5-bfbf-7e53ec33bafe",
    },
  });
};

export const getVideoUrl = async (botId) => {
  try {
    const response = await siteCall({
      url: urls.base_url + `/video/get_url/${botId}`,
      method: "GET",
      successCallback: (response) => response,
      errorCallback: (error) => {
        throw error;
      },
    });

    if (response.status !== 200) {
      throw new Error(`Failed to fetch video URL. Status: ${response.status}`);
    }

    return response;
  } catch (error) {
    console.error("Error fetching video URL:", error);
    throw error;
  }
};

export const getCalendarAuthToken = async (data, context) => {
  return siteCall({
    url: "https://zavsvmd6apjwzeoq4nirta6rv40keexb.lambda-url.ap-south-1.on.aws/calendar/auth/generate_token",
    method: "POST",
    body: JSON.stringify({
      user_id: `${data.user_id}`,
    }),
    successCallback: (response) => {
      return response.data;
    },
    errorCallback: (error) => {
      console.log(error, "error in fetching");
      return error;
    },
  });
};

export const getCalendarVerificationLinkMS = async (data, context) => {
  console.log("MS Verification");
  return siteCall({
    url: urls.base_url + "/calendar/auth",
    method: "POST",
    body: JSON.stringify({
      user_id: `${data.user_id}`,
      platform: "microsoft",
    }),
    successCallback: (response) => {
      return response.data;
    },
    errorCallback: (error) => {
      console.log(error, "error in fetching");
      return error;
    },
  });
};

export const getCalendarVerificationLink = async (data, context) => {
  console.log("google verification")
  return siteCall({
    url: urls.base_url + "/calendar/auth",
    method: "POST",
    body: JSON.stringify({
      user_id: `${data.user_id}`,
      platform: "google",
    }),
    successCallback: (response) => {
      return response.data;
    },
    errorCallback: (error) => {
      console.log(error, "error in fetching");
      return error;
    },
  });
};

export const listCalendarMeetings = async (data, context) => {
  return siteCall({
    url: urls.base_url + "/calendar/meeting/list_meetings",
    method: "POST",
    body: JSON.stringify({
      user_id: `${data.user_id}`,
      before: `${data.before}`,
      after: `${data.after}`,
    }),
    successCallback: (response) => {
      return response.data;
    },
    errorCallback: (error) => {
      console.log(error, "error in fetching");
      return [];
    },
  });
};

export const updateRecordingStatus = async (data, context) => {
  return siteCall({
    url: urls.base_url + "/calendar/meeting/update_recording_status",
    method: "POST",
    body: JSON.stringify({
      user_id: `${data.user_id}`,
      calendar_meeting_id: `${data.calendar_meeting_id}`,
      override_should_record: `${data.override_should_record}`,
    }),
    successCallback: (response) => {
      return response.data;
    },
    errorCallback: (error) => {
      console.log(error, "error in fetching");
      return error;
    },
  });
};

export const setDefaultCalendarPreference = async (data, context) => {
  return siteCall({
    url: urls.base_url + "/calendar/settings/enable_disable_bots",
    method: "POST",
    body: JSON.stringify({
      user_id: `${data.user_id}`,
      enable_bots: true,
    }),
    successCallback: (response) => {
      return response.data;
    },
    errorCallback: (error) => {
      console.log(error, "error in fetching");
      return error;
    },
  });
};
export const setDefaultBotName = async (data, context) => {
  return siteCall({
    url: urls.base_url + "/calendar/settings/set_bot_name",
    method: "POST",
    body: JSON.stringify({
      user_id: `${data.user_id}`,
      bot_name: `${data.bot_name}`,
    }),
    successCallback: (response) => {
      return response.data;
    },
    errorCallback: (error) => {
      console.log(error, "error in fetching");
      return error;
    },
  });
};
